// @ts-nocheck
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";

import Schemas from "schemas";
import styled from "styled-components";

import { Control } from "components/ui-kit/control";
import { AuthStyles, Button, Frame, Logo } from "components/ui-kit/styled-templates";

import UserApi from "api/user-api";

import useFormControl from "hooks/useFormControl";

import { EForms, ERoles } from "types/enums";

function validatePhoneNumber(phoneNumber) {
    const regex = /^[\d+\(\)\-\s]+$/; // Allows digits, +, (), -, and spaces
    return regex.test(phoneNumber) && phoneNumber.length <= 16;
}

const SignUpPage = (props: { role: ERoles.Student | ERoles.University }) => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const { role } = props;

    const [universities, setUniversities] = useState([]);
    const [selectedUniversity, setSelectedUniversity] = useState(null);

    useEffect(() => {
        // Load universities list
        axios.get("/universities/all").then((response) => {
            setUniversities(response.data);
        }).catch((error) => {
            console.error("Error loading universities:", error);
        });
    }, []);

    // Prepare university options with format: "Short name (Full name)"
    const universityOptions = [
        ...universities
            .filter(uni => uni?.details?.shortName || uni?.details?.name)
            .map(uni => {
                const shortName = uni?.details?.shortName || "";
                const fullName = uni?.details?.name || "";
                const label = shortName && fullName
                    ? `${shortName} (${fullName})`
                    : shortName || fullName;
                return {
                    value: uni.id,
                    label: label
                };
            })
            .sort((a, b) => a.label.localeCompare(b.label, isRu ? 'ru' : 'en')),
        { value: "", label: isRu ? "Другое" : "Other" }
    ];

    const { onSubmit } = useFormControl({
        name: { [ERoles.University]: EForms.signUpUni, [ERoles.Student]: EForms.signUpStudent }?.[role],
        schema: role === ERoles.Student ? Schemas.signup[ERoles.Student] : Schemas.signup[ERoles.University],
    });
    const handlers = {
        submit: async (data: Object) => {
            // return window.alert("Регистрация откроется 10 апреля.");
            if (validatePhoneNumber(data?.phone) == false){
                return window.alert("Неверный формат номера телефона");
            }
            if (role === ERoles.Student) {
                await UserApi.signup({
                    ...data,
                    userUniversityId: selectedUniversity?.value || "",
                    referralUserId: localStorage.getItem("referralUserId"),
                });
            }
        },
    };
    return (
        <Frame extra={`min-height: inherit; width: inherit;`} className={'signup_frame'} >
            <AuthStyles.Container>
                <Link to="/">
                    <Logo />
                </Link>
                <h2 style={{marginTop: 15, marginBottom: 10}} >{t("6zpnypmqqt")}</h2>
                {role === ERoles.University && <p>{t("welokig2ate")}</p>}
                {role === ERoles.Student && <p style={{marginTop: '4px'}} >{t("mxrscfq93o")}</p>}
                <Control.Form
                    name={{ [ERoles.University]: EForms.signUpUni, [ERoles.Student]: EForms.signUpStudent }?.[role]}
                    onSubmit={onSubmit(handlers.submit)}
                >
                    {/* {role === ERoles.University && (
                        <>
                            <Control.Textarea
                                name="name"
                                placeholder="Наименование образовательной организации"
                                label="Наименование образовательной организации"
                            />
                            <Control.Input
                                name="committe"
                                placeholder="Наименование организационного комитета"
                                label="Наименование организационного комитета"
                            />
                            <Control.Input name="phone" placeholder="Контактный телефон" label="Контактный телефон" />
                            <Control.Input name="email" placeholder="Электронная почта" label="Электронная почта" />
                        </>
                    )} */}
                    {role === ERoles.Student && (
                        <>
                            <Control.Input name="name" placeholder={t("o5vrbg4l24")} label={t("dha7f5892un")} />
                            {/* studentRoleType обучающийся или молодой специалист */}
                            <Control.Select
                                name="studentRoleType"
                                placeholder={t("signupStudentRole.label")}
                                label={t("signupStudentRole.label")}
                                options={[
                                    { value: "student", label: t("signupStudentRole.student") },
                                    { value: "youngSpecialist", label: t("signupStudentRole.youngSpecialist") },
                                    { value: "youngScientist", label: t("signupStudentRole.youngScientist") },
                                ]}
                            />
                            <Control.Input name="phone" placeholder={'+7 000 000 00 00'} label={t("sijlzz8ll3")} />
                            <Control.Input name="email" placeholder={t("57u4slpi82j")} label={t("e7zcoqnd9qg")} />
                            <Control.Password name="password" placeholder={t("e8hyd29rsl")} label={t("le1tiuhgwgs")} />
                            <UniversitySelectWrapper>
                                <label>{isRu ? "ВУЗ" : "University"}</label>
                                <Select
                                    value={selectedUniversity}
                                    onChange={setSelectedUniversity}
                                    options={universityOptions}
                                    placeholder={isRu ? "Выберите ВУЗ" : "Select university"}
                                    isClearable
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '48px',
                                            borderRadius: '4px',
                                            borderColor: '#d9d9d9',
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                            </UniversitySelectWrapper>
                        </>
                    )}
                    <Button type="submit" background="blue" extra={`width: 100%; padding: `}>
                        {t("d8qle1bu7oh")}
                    </Button>

                    <PolicyWrapper>
                        {t("w2v1x73x9db")}
                        <br />
                        <PolicyLink href={"/studpolicy.pdf"}>{t("x97tvgznlnj")}</PolicyLink>
                    </PolicyWrapper>

                    <PolicyWrapper style={{fontSize: '12px', padding: '3px'}}>
                        {isRu ?
                            <>
                                Уже есть аккаунт? <Link to="/login">Войти</Link>
                            </>
                            :
                            <>
                                Already have an account? <Link to="/login">Sign in</Link>
                            </>
                        }

                    </PolicyWrapper>



                    {/* <AuthStyles.LinksWrapper>
                        {role === ERoles.University && <Link to="/registration/student">Регистрация для студентов</Link>}
                        {role === ERoles.Student && <Link to="/registration/university">Регистрация для образовательных организаций</Link>}
                    </AuthStyles.LinksWrapper> */}
                </Control.Form>
            </AuthStyles.Container>
        </Frame>
    );
};

const PolicyWrapper = styled.div`
    font-size: 10px;
    opacity: 0.7;
    text-align: center;
    padding: 7px;
`;

const PolicyLink = styled.a`
    text-decoration: underline;
    opacity: 0.5;

    :hover {
        opacity: 1;
    }
`;

const UniversitySelectWrapper = styled.div`
    margin-bottom: 20px;

    label {
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }
`;

export default SignUpPage;
